module.exports = __webpack_public_path__ + "img/flag.110b52df.jpg";